export const hasCmsEnabled = libraryMap => {
  return libraryMap?.get('cmsEnabled') ?? false;
};

export const hasPromosEnabled = libraryMap => {
  const hasPromos = libraryMap?.get('hasPromos') ?? false;
  const hasPromosAddOn = libraryMap.get('hasPromosAddOn') ?? false;

  return hasPromos && (hasCmsEnabled(libraryMap) || hasPromosAddOn);
};

export const getCmsHost = libraryMap => {
  if (!hasCmsEnabled(libraryMap)) {
    return null;
  }

  return libraryMap.get('cmsUrl') ?? null;
};
